<template>
    <b-card class="contenedor" header-class="text-center font-weight-bold" header="Pictogramas SGA">
        <b-row>
            <b-col sm="12" class="text-center">
                <h5 class="font-weight-bold">
                    Clasificación
                </h5>
                <b-img v-for="(pictograma, index) in pictogramas.homologacion" :key="'c' + index" style="height:75px;"
                    :src="pictograma.direccion" img-alt="Image" tag="article" class="m-2 p-1 rounded border bg-light" />
                <h6 v-if="pictogramas.homologacion && typeof pictogramas.homologacion === 'object' ? pictogramas.homologacion.length <= 0 : []"
                    class="text-center text-danger my-4">
                    <i class="fa fa-exclamation-circle" /> {{ clasificacionSGAListas.sinSGA }}
                </h6>

                <hr>
                <div v-if="validarPermisoComponente('editar-sistemas-clasificacion-productos-nuevo-y-antiguo') && !desactivar_edicion">
                    <h5 class="font-weight-bold">
                        Homologación
                    </h5>
                    <b-img v-for="(pictograma, index) in pictogramas.clasificacion" :key="'h' + index"
                        style="height:75px;" :src="pictograma.direccion" img-alt="Image" tag="article"
                        :class="claseImagen(pictograma)" @click="cambiaEstado(pictograma)" />
                </div>

            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import loader from './../../../../containers/loader';
import { validarPermisoComponente } from '../../../../plugins/acl';
export default {
    name: 'Pictogramas-homologacion',
    props: {
        desactivar_edicion: {
            type: Boolean,
            default: false,
            required: false
        },
    },
    data() {
        return {
            loading: false,
            validarPermisoComponente: validarPermisoComponente
        };
    },
    created() {
    },
    components: {
        loader
    },
    computed: {
        ...mapState('sgacompleto', ['selectedSgaCompleto', 'clasificacionSGAListas', 'version', 'idioma']),
        ...mapState('etiquetas', ['VisualEmpresa']),
        ...mapState('sga', ['idiomas', 'versiones', 'pictogramas'])
    },
    methods: {
        actualizarSgaCompleto() {
            this.getSgaCompleto(this.$route.params.id);
        },
        claseImagen(pictograma) {
            let clase = 'm-2 p-1 rounded border ';

            if (!!this.pictogramas.homologacion.find(p => p.imagen === pictograma.imagen)) {
                clase += 'seleccionado bg-success';
            } else {
                clase += 'pictograma bg-danger';
            }

            return clase;
        },
        ...mapActions('sgacompleto', ['getSgaCompleto']),
        ...mapActions('sga', ['cambiaEstado']),
        ...mapMutations('sgacompleto', ['cambiaIdioma', 'cambiaVersion']),
        _cambiaEstado(pictograma) {
            if (!this.desactivar_edicion) {
                this.cambiaEstado(pictograma);
            }
        }
    }
};
</script>

<style scoped>
.pictograma {
    background: #eaeaea;
    opacity: 0.2;
    cursor: pointer;
}

.seleccionado {
    opacity: 1;
    cursor: pointer;
    background: #e3ffd9;
}
</style>
